/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { GLOBALS } from '../../utils/Globals'
import './style.scss'

export const SuccessViewLab = () => {
  const [redirectTo, setRedirectTo] = useState(null)

  const config = {
    title: 'Volver',
    icon: GLOBALS.menu.dashboard.icon,
    link: GLOBALS.menu.dashboard.link,
    linkList: GLOBALS.menu.dashboard.linkList,
  }

  const volverAlInicio = () => {
    setRedirectTo({
      pathname: config.linkList,
      state: { success: true },
    })
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return (
    <div className="success-view-lab">
      <div className="container">
        <div className="icon">🔒</div>
        <h1 className="title">Sesión Finalizada</h1>
        <p className="message">Gracias por usar el servicio de Elvira, hasta la próxima!</p>
        <button onClick={volverAlInicio} className="button">
          Volver al Inicio
        </button>
      </div>
    </div>
  )
}
